import React, { useState } from 'react';
import { deleteDidPorted, didPortedListing } from '../../../api-services';
import { useMutation, useQueryClient } from 'react-query';
import { Dropdown } from 'react-bootstrap';
import swal from 'sweetalert';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash,
  faEllipsisV,
  faEdit,
} from '@fortawesome/free-solid-svg-icons';
import TableManager from '../../../components/TableManager';
import { createTable } from '@tanstack/react-table';
import AddPorted from './modal/AddPorted';

const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Custom', value: 'Custom' },
];

const statusOptions = [
  { label: 'Activated', value: 'A' },
  { label: 'Deactivated', value: 'D' },
  { label: 'Pending', value: 'P' },
];

const initialValues = {
  filter: [
    {
      account_number: '',
      a_filter_type: '',
      placeholder: 'Enter MSISDN...',
      type: 'number',
      shouldFilterOptionDisabled: false,
      // filterOptions: numberFilterTypes,
      label: 'MSISDN',
    },
    {
      did_number: '',
      a_filter_type: '',
      placeholder: 'Enter Did No...',
      type: 'number',
      shouldFilterOptionDisabled: false,
      label: 'Did No',
    },
    {
      did_status: '',
      a_filter_type: '',
      placeholder: 'Select Status...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: statusOptions,
      label: 'Status',
    },
    {
      did_city: '',
      a_filter_type: '',
      placeholder: 'Enter City',
      type: 'text',
      shouldFilterOptionDisabled: false,
      label: 'City',
    },
    {
      date: {
        from: '',
        to: '',
      },
      a_filter_type: '',
      placeholder: 'Custom Date Range...',
      type: 'date',
      shouldFilterOptionDisabled: false,
      filterOptions: DateFilterTypes,
      selectOptions: [],
      label: 'Date',
    },
  ],
};
const table = createTable();
const Ported = () => {
  const queryClient = useQueryClient();
  const [openModal, setOpenModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);

  const { mutateAsync: mutateAsyncdelete } = useMutation(
    'delete-did-ported',
    deleteDidPorted,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('ported-did-listing');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          // text: "Error",
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const handleEditData = (data) => {
    setOpenModal(true);
    setEditData(data);
  };
  const deleteUserList = (data) => {
    swal({
      text: 'Are you sure you want to delete this Ported DID ?',
      buttons: true,
      icon: 'warning',
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          let payload = {
            uniquecode: data?.uniquecode,
          };
          await mutateAsyncdelete(payload);
        } catch (error) {
          console.log(error);
        }
      }
    });
  };
  const handleCtaFunction = () => {
    setOpenModal(true);
    setEditData({});
  };

  const statusView = { A: 'Activated', D: 'Deactivated', P: 'Pending' };
  const columns = [
    table.createDataColumn('created_at', {
      id: 'created_at',
      header: 'Date',
      cell: (props) => moment(props.getValue()).format('YYYY-MM-DD: HH:mm:ss'),
    }),
    table.createDataColumn('created_at', {
      id: 'msisdn',
      header: 'MSISDN',
      cell: (props) => {
        const data = props?.row?.original;
        return data?.customer?.msisdn || '---';
      },
    }),
    table.createDataColumn('did_number', {
      id: 'did_number',
      header: 'DID No.',
    }),
    table.createDataColumn('buy_date', {
      id: 'buy_date',
      header: 'Buy Date',
      cell: (props) => moment(props.getValue()).format('YYYY-MM-DD'),
    }),
    table.createDataColumn('renewal_date', {
      id: 'renewal_date',
      header: 'Renewal Date',
      cell: (props) => moment(props.getValue()).format('YYYY-MM-DD'),
    }),
    table.createDataColumn('did_status', {
      id: 'did_status',
      header: 'Status',
      cell: (props) => statusView[props?.getValue()],
    }),
    table.createDataColumn('did_city', {
      id: 'ciity',
      header: 'City',
    }),

    table.createDisplayColumn({
      id: 'action',
      header: 'Action',
      cell: (props) => (
        <span>
          <Dropdown className="dropdown_dot mx-auto">
            <Dropdown.Toggle
              id="dropdown-basic"
              className="btn-light-blue btn-action "
            >
              <FontAwesomeIcon icon={faEllipsisV} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                href={void 0}
                onClick={() => handleEditData(props.row.original)}
              >
                <FontAwesomeIcon icon={faEdit} /> Edit
              </Dropdown.Item>
              <Dropdown.Item
                href={void 0}
                onClick={() => deleteUserList(props.row.original)}
              >
                <FontAwesomeIcon icon={faTrash} />
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </span>
      ),
    }),
  ];
  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        title="Ported Did"
        fetcherKey="ported-did-listing"
        fetcherFn={didPortedListing}
        cta={true}
        ctaFunction={handleCtaFunction}
        ctaLabel="Add Ported"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={initialValues}
        setFilters={setFilters}
        filters={filters}
      />

      {openModal && (
        <AddPorted
          {...{
            openModal,
            setOpenModal,
            editData,
            setEditData,
          }}
        />
      )}
    </>
  );
};

export default Ported;
